import { memo } from 'react';

import { ChevronLeft, ChevronRight } from 'lucide-react';

import Button from '@mui/material/Button';

import { LIMIT_OPTIONS } from '../constants';

import css from './CursorPagination.module.css';

import { Select } from 'v2/components/select/Select';
import { ICursorPagination } from 'v2/hooks/useCursorPagination';
import { Nullable } from 'v2/types';

interface CursorPaginationProps {
  pagination: ICursorPagination;
  nextCursor?: Nullable<string>;
  limit: number;
  onLimitChange: (limit: number) => void;
  disabled?: boolean;
}

export const CursorPagination = memo<CursorPaginationProps>(
  ({ pagination, nextCursor, limit, onLimitChange, disabled }) => (
    <div className={css.cursorPagination}>
      <div className={css.limit}>
        <Select size="small" label="Rows" value={limit} options={LIMIT_OPTIONS} onChange={onLimitChange} />
      </div>

      <span className={css.page}>Page {pagination.page}</span>

      <Button
        size="small"
        startIcon={<ChevronLeft width={16} height={16} />}
        disabled={disabled || !pagination.hasPrev}
        onClick={pagination.onPrev}
      >
        Prev
      </Button>

      <Button
        size="small"
        endIcon={<ChevronRight width={16} height={16} />}
        disabled={disabled || !nextCursor}
        onClick={() => nextCursor && pagination.onNext(nextCursor)}
      >
        Next
      </Button>
    </div>
  )
);

CursorPagination.displayName = 'CursorPagination';
